<template>
    <div class="talk">
        <div class="head">
            <div class="head-body" style="cursor: pointer;" @click="changeShow = !changeShow">提问/交流</div>
        </div>
        <div v-show="changeShow" class="body">
            <div class="body-head">
                <img :src="this.$store.state.me.photo" style="border-radius: 50%; margin-top: 5px" width="50px" height="50px" 
                alt="你的头像">
                <div class="home">
                    <mavon-editor :boxShadow="false" :codeStyle="codeStyle" :toolbars="toolbars" :tabSize="tabSize" v-model="content" 
                    :ishljs="true" ref="md" @change="change" style="margin-left: 18px; min-width: 1050px; max-width: 1050px; 
                    min-height:500px; max-height: 500px;"/>
                </div>
                <el-button style="width: 70px; height: 40px; margin:10px 0px 0px 10px;" @click="CreateCourseTalk">发表</el-button> 
            </div>
        </div>

        <div class="body" v-for="item in list" :key="item.id">
            <div class="body-content" @mouseover="showText = item.id" @mouseleave="showText = 0">
                <div style="height: auto; width: 50px;">
                    <img :src="item.photo" style="border-radius: 50%; margin-top: 5px;" width="50px" height="50px" alt="你的头像">
                </div>
                <div style="margin-left: 17px; height: auto;">
                    <p style="font-size: 13px; color: red; margin-top: 5px; ">{{ item.userName }} 
                        <span style="color: #909399; margin-left: 5px;">{{ item.createTime }}</span>
                        <span v-show="item.userId == $store.state.me.id && showText == item.id" style="
                            float: right; color: #25BB9B; font-size: 14px; cursor: pointer;" @click="ClickDelete(item.id)">
                            删除
                        </span>
                    </p>
                    <div class="ueditor" >
                        <mavon-editor class="markdown-body" :boxShadow="false" style="min-width: 1050px; max-width: 1050px; 
                        min-height: 10px;" codeStyle="monokai" v-html="item.content"></mavon-editor>
                        <Reply v-if="open" :item="item"></Reply>   
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url'
    import Reply from './Reply.vue'
    export default {
        name:'TalkAbout',
        components: {
            Reply,
        },
        data() {
            return {    
                showText:0,
                open: false,
                changeShow: false,
                flag: false,
                list:[], // 主贴内容
                relpy:'',

                content: "# 发表你的见解", // 这个是markdown
                tabSize:4,
                page_article:undefined,
                html_content:undefined,
                md_content:undefined,
                toolbars: {
                    bold: true, // 粗体
                    italic: true, // 斜体
                    header: true, // 标题
                    underline: true, // 下划线
                    strikethrough: true, // 中划线
                    mark: true, // 标记
                    superscript: true, // 上角标
                    subscript: true, // 下角标
                    quote: true, // 引用
                    ol: true, // 有序列表
                    ul: true, // 无序列表
                    link: true, // 链接
                    imagelink: true, // 图片链接
                    code: true, // code
                    table: true, // 表格
                    fullscreen: true, // 全屏编辑
                    readmodel: true, // 沉浸式阅读
                    htmlcode: true, // 展示html源码
                    help: true, // 帮助
                    undo: true, // 上一步
                    redo: true, // 下一步
                    trash: true, // 清空
                    save: true, // 保存（触发events中的save事件）
                    navigation: true, // 导航目录
                    alignleft: true, // 左对齐
                    aligncenter: true, // 居中
                    alignright: true, // 右对齐
                    subfield: true, // 单双栏模式
                    preview: true // 预览
                },
                codeStyle:'monokai-sublime',//主题
                test_html:undefined, // 这个才是实际内容
            }
        },
        mounted() {
            this.ReadCourseTalk()
        },
        methods: {
            CreateCourseTalk() {
                const vue = this
                const store = this.$store
                const route = this.$route
                
                $.ajax({
                    url: Url.cCourseTalkUrl,
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        userId: store.state.me.id,
                        userName: store.state.me.name,
                        content: vue.test_html,
                        courseId: route.params.Vid,
                        markdown: vue.content,
                        photo: store.state.me.photo
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("发表成功")
                            vue.ReadCourseTalk()
                        } 
                    }
                })
            },
            ClickDelete(id) {
                const vue = this
                const store = this.$store

                $.ajax({
                    url: Url.dCourseTalkUrl,
                    type:'post',
                    data: {
                        id: id,
                    },
                    headers: {
                        Authorization: "Bearer " + store.state.me.token
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("删除成功")
                            vue.ReadCourseTalk()
                        }
                    }
                })
            },
            ReadCourseTalk() {
                const vue = this
                const store = this.$store
                const route = this.$route
                
                $.ajax({
                    url: Url.rCourseTalkUrl,
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        courseId: route.params.Vid
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("获取成功")
                            vue.list = JSON.parse(resp.value);
                            vue.open = true
                        }
                    }
                })
            },
            change(value, render){
                // render 为 markdown 解析后的结果
                // console.log(render)
                this.test_html = render;
            },
        }
    }
</script>

<style scoped>
.body-content {
    margin-top: 20px;
    display: flex;
    float: left;
    width: 1120px;
}
.head {
    width: 100%;
    border-bottom: 3px solid #25BB9B;
}
.head-body {
    text-align: center;
    width: 99.9px;
    height: 42px;
    line-height: 42px;
    font-size: 14px;
    background-color: #25BB9B;
    color: white;
}
.body {
    margin-top: 6px;
    width: 1220px;
    height: auto;
    margin-bottom: 10px;
}
.body-head {
    display: flex;
    float: left;
}
.talk {
    width: 96%;
    min-height: 600px; 
    margin-top: 20px;
    margin-left: calc(2%);
}
</style>